import { Component, Input, OnInit } from '@angular/core';
import { PlatformSystemSettings } from '@core/models';
import { CatalogueService } from '@core/shared/services/catalogue.service';
import * as fromStore from '@core/store';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'cs-redeem-now',
    templateUrl: 'redeem-now.component.html',
    styleUrls: ['redeem-now.component.scss']
})

export class RedeemNowComponent implements OnInit {
    @Input() buttonTheme;
    private onDestroy$ = new Subject<void>();
    menuAccess: any;
    disablePopover = true;
    disableMerchandise = true;
    disableExperience = true;
    systemSettings: PlatformSystemSettings;

    constructor(private catalogueService: CatalogueService, private store: Store<fromStore.PlatformState>, private router: Router) {
        this.store.select(fromStore.globalMenuState).pipe(takeUntil(this.onDestroy$)).subscribe(state => {
            if (state && state.menuAccess && this.systemSettings) {
                this.menuAccess = state.menuAccess;
                this.checkShop();
            }
        });
    }

    ngOnInit(): void {
        if (localStorage.getItem('platformSettings')) {
            this.systemSettings = JSON.parse(localStorage.getItem('platformSettings'));
            if (this.menuAccess == undefined) {
                this.store.select(fromStore.globalMenuState).pipe(takeUntil(this.onDestroy$)).subscribe(state => {
                    if (state && state.menuAccess && this.systemSettings) {
                        this.menuAccess = state.menuAccess;
                        this.checkShop();
                    }
                });
            } else {
                this.checkShop();
            }
        }
    }

    //experianceCatelogue() {
    //    this.router.navigate([`/catalogue/verification/experience`]);
    //}

    //merchandiseCateloge() {
    //    this.router.navigate([`/catalogue/verification/merchandise`]);
    //}
    experianceCatelogue() {
        this.catalogueService.redirectExperianceCatalogue();
    }

    merchandiseCateloge() {
        this.catalogueService.redirectMerchandiseCatalogue();
    }

    checkShop() {
        this.disablePopover = true;
        if (this.systemSettings.catalogueReferences.filter(x => x.isEnableMerchandise).length > 0 && this.menuAccess && this.menuAccess.merchandise) {
            this.disablePopover = false;
            this.disableMerchandise = false;
        }
        if (this.systemSettings.catalogueReferences.filter(x => x.isEnableExperience).length > 0 && this.menuAccess && this.menuAccess.experience) {
            this.disablePopover = false;
            this.disableExperience = false;
        }
    }
}